import { LANGUAGES } from '../config'
import { pl } from '../dictionaries/pl'

export const getDictionary = (lang: LANGUAGES) => {
  switch (lang) {
    case 'pl':
      return pl
    default:
      return pl
  }
  // switch (lang) {
  //   case 'pl':
  //     return import('../dictionaries/pl').then(module => module.pl)
  //   default:
  //     return import('../dictionaries/pl').then(module => module.pl)
  // }
}
